<template>
  <div>    
    <CoreManager></CoreManager>
  </div>
</template>

<script>
import CoreManager from '../components/CoreManager.vue';

export default {
  components: {
    CoreManager,
  },
};
</script>